module.exports = __webpack_public_path__ + "static/media/Pullman Avenue, Half Moon Bay, CA12.11c3bd8c.jpg";